import { Button, Grid, TextField } from '@mui/material'
import React from 'react'
import MainCard from 'ui-component/cards/MainCard'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useState } from 'react';
import StatusTable from './Components/SBI_KO/StatusTable';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Menu from '@mui/material/Menu';
import { Stack } from '@mui/system';
import { styled } from '@mui/material/styles';



const SbiKiosk = () => {

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });



    const [BankName, setBankName] = useState('');
    const [requestId, setRequestId] = useState(null);
    const [activePage, setActivePage] = React.useState('one');
    const [anchorEl, setAnchorEl] = React.useState(null);



    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    console.log(requestId);

    const handleChange = (event) => {
        setBankName(event.target.value);
    };

    const handleChangeFilter = (field, value) => {
        if (field === 'requestid') {
            setRequestId(value)
        }
    }


    const handleSetActivePage = (event, newValue) => {
        // console.log("value", value);
        setActivePage(newValue)
    }



    return (
        <>

            <MainCard title="SBI Kiosk Admin Panel">
                <Grid container alignItems='center' justifyContent='left' spacing={2}>
                    <Grid item xl={12}>
                        <Grid item xl={12} sm={12} xs={12}>
                            <Tabs
                                value={activePage}
                                onChange={handleSetActivePage}
                                textColor="secondary"
                                indicatorColor="secondary"
                                aria-label="secondary tabs example"
                                centered
                            >
                                <Tab value="one" label="KO Deposit" />
                                <Tab value="two" label="KO Withdrawl" />
                                <Tab value="three" label="KO Deposit  in SBI Settlement A/c 469" />
                            </Tabs>
                        </Grid>

                    </Grid>
                </Grid>
                {
                    activePage === 'one' ?
                        <Grid container mt={2} gap={2} alignItems='center'>
                            <Grid item xs={12} sm={12} md={6} lg={3} xl={3} >
                                <FormControl fullWidth>
                                    <InputLabel id="demo-select-label">Fia Account</InputLabel>
                                    <Select
                                        labelid="demo-select-label"
                                        id="demo-select-small"
                                        value={BankName}
                                        label="Fia Account"
                                        onChange={handleChange}
                                    >
                                        <MenuItem value={10}>Ten</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xl={3}>
                                <TextField
                                    label="Amount"
                                    onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xl={3}>
                                <TextField
                                    label="Request ID"
                                    onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xl={3}>
                                <TextField
                                    label="Agent Code"
                                    onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xl={3}>
                                <div>
                                    <TextField
                                        id="demo-positioned-button"
                                        aria-controls={open ? 'demo-positioned-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                        onClick={handleClick}
                                        variant='outlined'
                                        color="dark"
                                        label="Date"
                                        fullWidth
                                        contentEditable={false}
                                    >

                                    </TextField>
                                    <Menu
                                        id="demo-positioned-menu"
                                        aria-labelledby="demo-positioned-button"
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                    >
                                        <MenuItem>
                                            <Stack direction={{ xl: 'row', lg: 'row', md: 'row', sm: 'column', xs: 'column' }} alignItems='center' gap={2}>
                                                <TextField
                                                    id="date"
                                                    label="From"
                                                    type="date"
                                                    defaultValue="yyyy-mm-dd"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                                to
                                                <TextField
                                                    id="date"
                                                    label="To"
                                                    type="date"
                                                    defaultValue="yyyy-mm-dd"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Stack>
                                        </MenuItem>
                                        <MenuItem>
                                            <Button variant='outlined' fullWidth>Today</Button>
                                        </MenuItem>
                                        <MenuItem>
                                            <Button variant='outlined' fullWidth>Yesterday</Button>
                                        </MenuItem>
                                        <MenuItem>
                                            <Button variant='outlined' fullWidth>This Month</Button>
                                        </MenuItem>
                                        <MenuItem>
                                            <Button variant='outlined' fullWidth>Past Month</Button>
                                        </MenuItem>

                                    </Menu>
                                </div>

                            </Grid>
                            <Grid item xl={3}>
                                <TextField
                                    label="KO ID"
                                    onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xl={3}>
                                <TextField
                                    label="Remarks"
                                    onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xl={3}>
                                <Button variant='outlined'>Apply filter</Button>
                            </Grid>
                        </Grid>
                        :
                        activePage === 'two' ?
                            <Grid container mt={2} gap={2} alignItems='center'>

                                <Grid item xl={3}>
                                    <TextField
                                        label="KO ID"
                                        onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xl={3}>
                                    <TextField
                                        label="Request ID"
                                        onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xl={3}>
                                    <TextField
                                        label="Agent Code"
                                        onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xl={3}>
                                    <div>
                                        <TextField
                                            id="demo-positioned-button"
                                            aria-controls={open ? 'demo-positioned-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            onClick={handleClick}
                                            variant='outlined'
                                            color="dark"
                                            label="Date"
                                            fullWidth
                                            contentEditable={false}
                                        >

                                        </TextField>
                                        <Menu
                                            id="demo-positioned-menu"
                                            aria-labelledby="demo-positioned-button"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                        >
                                            <MenuItem>
                                                <Stack direction={{ xl: 'row', lg: 'row', md: 'row', sm: 'column', xs: 'column' }} alignItems='center' gap={2}>
                                                    <TextField
                                                        id="date"
                                                        label="From"
                                                        type="date"
                                                        defaultValue="yyyy-mm-dd"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    to
                                                    <TextField
                                                        id="date"
                                                        label="To"
                                                        type="date"
                                                        defaultValue="yyyy-mm-dd"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </Stack>
                                            </MenuItem>
                                            <MenuItem>
                                                <Button variant='outlined' fullWidth>Today</Button>
                                            </MenuItem>
                                            <MenuItem>
                                                <Button variant='outlined' fullWidth>Yesterday</Button>
                                            </MenuItem>
                                            <MenuItem>
                                                <Button variant='outlined' fullWidth>This Month</Button>
                                            </MenuItem>
                                            <MenuItem>
                                                <Button variant='outlined' fullWidth>Past Month</Button>
                                            </MenuItem>

                                        </Menu>
                                    </div>

                                </Grid>
                                <Grid item xl={3}>
                                    <TextField
                                        label="Mobile No"
                                        onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xl={3}>
                                    <TextField
                                        label="Remarks"
                                        onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xl={3}>
                                    <Button variant='outlined'>Apply filter</Button>
                                </Grid>
                            </Grid>
                            :
                            <Grid container mt={2} gap={2} alignItems='center'>
                                <Grid item xs={12} sm={12} md={6} lg={3} xl={3} >
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-select-label">Fia Bank</InputLabel>
                                        <Select
                                            labelid="demo-select-label"
                                            id="demo-select-small"
                                            value={BankName}
                                            label="Fia Account"
                                            onChange={handleChange}
                                        >
                                            <MenuItem value={10}>Ten</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xl={4} md={6} sm={12} xs={12}>
                                    <TextField
                                        type="text"
                                        fullWidth
                                        disabled
                                        name="bank_recipt"
                                        label="Bank Recipt"
                                        value={BankName}
                                        InputProps={{
                                            endAdornment: (
                                                <Button
                                                    component="label"
                                                    role={undefined}
                                                    variant="contained"
                                                    tabIndex={-1}
                                                    color='secondary'
                                                >
                                                    Upload
                                                    <VisuallyHiddenInput onChange={(e) => handleFileUpload(e.target.files[0], setFieldValue)} type="file" />
                                                </Button>
                                            ),
                                        }}
                                    />
                                    
                                </Grid>

                                <Grid container spacing={2}>
                                <Grid item xl={3}>
                                    <TextField
                                        label="Request ID"
                                        onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xl={3}>
                                    <TextField
                                        label="Agent Code"
                                        onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xl={3}>
                                    <div>
                                        <TextField
                                            id="demo-positioned-button"
                                            aria-controls={open ? 'demo-positioned-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            onClick={handleClick}
                                            variant='outlined'
                                            color="dark"
                                            label="Date"
                                            fullWidth
                                            contentEditable={false}
                                        >

                                        </TextField>
                                        <Menu
                                            id="demo-positioned-menu"
                                            aria-labelledby="demo-positioned-button"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                        >
                                            <MenuItem>
                                                <Stack direction={{ xl: 'row', lg: 'row', md: 'row', sm: 'column', xs: 'column' }} alignItems='center' gap={2}>
                                                    <TextField
                                                        id="date"
                                                        label="From"
                                                        type="date"
                                                        defaultValue="yyyy-mm-dd"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    to
                                                    <TextField
                                                        id="date"
                                                        label="To"
                                                        type="date"
                                                        defaultValue="yyyy-mm-dd"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </Stack>
                                            </MenuItem>
                                            <MenuItem>
                                                <Button variant='outlined' fullWidth>Today</Button>
                                            </MenuItem>
                                            <MenuItem>
                                                <Button variant='outlined' fullWidth>Yesterday</Button>
                                            </MenuItem>
                                            <MenuItem>
                                                <Button variant='outlined' fullWidth>This Month</Button>
                                            </MenuItem>
                                            <MenuItem>
                                                <Button variant='outlined' fullWidth>Past Month</Button>
                                            </MenuItem>

                                        </Menu>
                                    </div>

                                </Grid>
                                <Grid item xl={3}>
                                    <TextField
                                        label="Ref Id"
                                        onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xl={3}>
                                    <TextField
                                        label="Remarks"
                                        onChange={(e) => handleChangeFilter('requestid', e.target.value)}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xl={1}>
                                    <Button variant='contained' color='success'>Submit</Button>
                                </Grid>

                                <Grid item xl={2}>
                                    <Button variant='outlined' color='primary'>Export to excel</Button>
                                </Grid>
                                </Grid>
                            </Grid>
                }
            </MainCard>
            <MainCard sx={{ marginTop: '20px' }}>
                <StatusTable />
            </MainCard>
        </>
    )
}

export default SbiKiosk
